<template>
  <div class="page">
    <div  class="main" v-for="item in dataList" :key="item.docID">
      <div class="info">
        <div>
          <div class="title">积分变动：</div>
          <div class="content">{{ item.amount }}</div>
        </div>
        <div>
          <div class="title">说明：</div>
          <div class="content">{{ item.comment }}</div>
        </div>
        <div>
          <div class="title">时间：</div>
          <div class="content">{{ item.timeStr }}</div>
        </div>
      </div>
    </div>
    <div v-if="dataList.length === 0 && canShow">
      <img
        src="./assets/list-none.png"
        alt=""
        width="250"
        class="table-empty"
      />
      <div>空荡荡的～暂无数据！</div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Utils from "./Utils";

export default {
  name: "home",

  mounted() {
    addEventListener("scroll", this.handleScroll); //监听函数
  },

  data() {
    return {
      dataList: [],
      canShow: false,
      pageIdx: 0
    };
  },

  created() {
    this.query();
  },

  methods: {
    goBack() {
      this.$router.back();
    },

    handleScroll() {
      //变量scrollTop是滚动条滚动时，距离顶部的距离
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      //变量windowHeight是可视区的高度
      let windowHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
      //变量scrollHeight是滚动条的总高度
      let scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      //滚动条到底部的条件
      if (scrollTop + windowHeight == scrollHeight) {
        //你想做的事情
        this.pageIdx++;
        this.query();
      }
    },

    //列表查询
    query() {
      let data = {
        orgID: Utils.userInfo.orgID,
        userID: Utils.userInfo.userID,
        pageSize: 100,
        pageIdx: this.pageIdx
      };
      let url = axios.defaults.baseURL.replace('v1/org/','')
      axios({
        method: "post",
        url: url+"v2/users/coupons",
        headers: { 
           'Authorization': this.$route.query.token,
            'PYDDot-Client-Type':this.$route.query.client,
            'X-Ca-Timestamp':parseInt(new Date().getTime()/1000)
         },
        data: data
      })  .then(value => {
        if(value.data.code!==0){
          this.$message.error( value.data.message) 
        }
          if (value && value.data && value.data.data) {
            value.data.data.forEach(data => {
              data.timeStr = Utils.long2second(data.time * 1000);
              this.dataList.push(data);
            });
          }
        })
        .catch(() => {})
        .finally(_ => {
          this.canShow = true;
          // this.dataList.push({
          //   amount: 1000,
          //   comment: "映射器是 MyBatis 中最重要、最复杂的组件，它由一个接口和对应的 XML 文件（或注解）组成。它可以配置以下内容：\n" +
          //           "描述映射规则。\n" +
          //           "提供 SQL 语句，并可以配置 SQL 参数类型、返回类型、缓存刷新等信息。\n" +
          //           "配置缓存。\n" +
          //           "提供动态 SQL。\n" +
          //           "\n" +
          //           "本节阐述两种实现映射器的方式，XML 文件形式和注解形式。不过在此之前，先用以下 SQL 语句创建 role 表。",
          //   timeStr: 1000,
          // });
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.page {
  box-sizing: border-box;
}

.main {
  justify-content: space-between;
  display: flex;
  width: 100%;
  box-sizing: border-box;
  padding: 10px;
  border-bottom: 1px gray solid;
}

.info {
  display: flex;
  flex-direction: column;
  align-items: start;
  min-width: 110px;
  div {
    margin-top: 5px;
    display: flex;
    .title {
      color: gray;
      text-align: right;
      width: 80px;
      min-width: 80px;
    }
  }
}

.table-empty {
  margin-top: 200px;
}
</style>
